'use strict'

import { combineReducers } from 'redux';
import update from 'immutability-helper';
import * as types from './types';
import * as usersTypes from '../users/types';
import * as attemptsTypes from '../attempts/types';

const byUsername = (
    state = {},
    action
) => {

	let stats, username, date, body;

    switch (action.type) {

        case types.FETCH_USER_STATS_COMPLETED:

			({ username, stats } = action.data);

			const userStats = state[ username ];

			if (userStats) {
				for (const date in stats) {
					if (userStats[ date ]) {
						const { attempts, serves, badAddresses } = stats[ date ];

						userStats[ date ] = {
							...userStats[ date ],
							attempts,
							serves,
							badAddresses
						}
					} else {
						userStats[ date ] = stats [ date ];
					}
				}
				return { ...state, [ username ]: userStats };
			}
			return { ...state, [ username ]: stats };

        case attemptsTypes.FETCH_USER_ATTEMPTS_COMPLETED:

			const { attempts } = action.data;
			({ body } = action.meta);
			({ username, date } = body);
			const attemptsByJob = {};
			
			attempts.forEach(a => {
				attemptsByJob[ a._id ] = a.attempts;
			});

			if (!(username in state)) {
				return {
					...state,
					[ username ]: {
						[ date ]: {
							attemptsByJob
						}
					}
				};
			}

			return {
				...state,
				[ username ]: {
					...state[ username ],
					[ date ]: {
						...state[ username ][ date ],
						attemptsByJob
					}
				}
			};
			
        case attemptsTypes.POST_ATTEMPT_COMPLETED:

			const { attempt } = action.data;
			const { jobId } = attempt;
			({ body } = action.meta);
			({ username, date } = body);

			let count = (jobId in state[ username ][ date ].attemptsByJob) ?
				state[ username ][ date ].attemptsByJob : 0;

			return {
				...state,
				[ username ]: {
					...state[ username ],
					[ date ]: {
						...state[ username ][ date ],
						attemptsByJob: {
							[ jobId ]: ++count
						}
					}
				}
			};

        default:
            return state;
    }
};

const userStats = combineReducers({
	byUsername
});
export default userStats;
